import { Button, Icon, Modal } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
const SomethingWentWrong = ({ closeModal, isOpen }) => {
    const { t } = useTranslation();
    return (<Modal open={isOpen} size="md" className="!min-w-0 !max-w-[min(540px,calc(100vw-32px))]" heading={t('financing.something_went_wrong.title')} onClose={closeModal} footer={<Button onClick={closeModal} variant="primary" label={t('financing.something_went_wrong.button')}/>}>
            <div className="flex flex-col items-center gap-3 text-center">
                <div className="w-12 h-12 bg-surface-critical-secondary-initial rounded-full border border-critical-primary-initial flex justify-center items-center">
                    <Icon name="error_filled" className="text-critical-primary-initial"/>
                </div>
                <p className="body-m text-neutral-secondary-initial">{t('financing.something_went_wrong.message')}</p>
            </div>
        </Modal>);
};
export default SomethingWentWrong;
